import { NavLink, useMatch, useResolvedPath } from 'react-router-dom';

import {
  Avatar,
  Chip,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { NavigationListItemButtonStyled } from '@kit/navigation';

import { NavigationItemType } from './types';

export const NavigationItem: NavigationItemType = (props) => {
  const { item, level } = props;
  const theme = useTheme();

  const Icon = item.icon!;
  const itemIcon = <Icon stroke="1.5" width={21} height={21} />;

  const resolved = useResolvedPath(item.url!);
  const match = useMatch({ path: resolved.pathname, end: false });

  return (
    <NavLink
      to={item.url ?? '/'}
      style={{
        textDecoration: 'none',
      }}
    >
      <NavigationListItemButtonStyled
        level={level}
        disabled={item.disabled}
        selected={Boolean(match)}
      >
        <ListItemIcon sx={{ my: 'auto', minWidth: !item?.icon ? 18 : 36 }}>
          {itemIcon}
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant={match ? 'h5' : 'body1'} color="inherit">
              {item.title}
            </Typography>
          }
          secondary={
            item.caption && (
              <Typography
                variant="caption"
                sx={{ ...theme.typography.subMenuCaption }}
                display="block"
                gutterBottom
              >
                {item.caption}
              </Typography>
            )
          }
        />
        {item.chip && (
          <Chip
            color={item.chip.color}
            variant={item.chip.variant}
            size={item.chip.size}
            label={item.chip.label}
            avatar={
              !item.chip.avatar ? undefined : (
                <Avatar>{item.chip.avatar}</Avatar>
              )
            }
          />
        )}
      </NavigationListItemButtonStyled>
    </NavLink>
  );
};
